import { css } from "styled-components";

// Absolute popup-ийг утсан дээр дэлгэцийн доороос гарах sheet болгоно.
// modalSelector: popup доторх цагаан хайрцгийн class (ж: ".modal")
export const mobileBottomSheet = (modalSelector = ".modal") => css`
  @media (max-width: 767px) {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    top: auto;

    ${modalSelector} {
      width: 100%;
      max-width: 100%;
      max-height: 85vh;
      overflow-y: auto;
      border-radius: 16px 16px 0 0;
    }
  }
`;

// Sheet нээлттэй үед ард нь харагдах бараан давхарга
export const mobileOverlay = css`
  @media (max-width: 767px) {
    background: rgba(0, 0, 0, 0.4);
  }
`;
